module.exports = __webpack_public_path__ + "img/newsImg2-2.04613001.png";